<template>
  <div class="text-sm text-gray-800 space-y-1">
    <div class="flex gap-x-2">
      <span class="font-medium text-gray-600">{{ $t('active_lines') }}</span>
      <span class="text-gray-900 font-semibold">{{ activeLinesLabel() }}</span>
    </div>


  </div>
</template>

<script>
export default {
  name: "LineSelectorDisplay",

  props: {
    configPage: {
      type: Object,
      required: true
    },
    activityGroups: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    activeLinesLabel() {
      const settings = this.configPage.settings || {};
      const lines = [];

      if (settings.baseLine) {
        lines.push(this.$t('baseline'));
      }
      if (settings.lastPlanned) {
        lines.push(this.$t('baseline_latest'));
      }
      if (settings.actual) {
        lines.push(this.$t('executed1'));
      }

      return lines.length > 0 ? lines.join(', ') : this.$t('none_selected');
    },
  }
}
</script>

